import { observer } from 'mobx-react-lite'
import { Modal } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'
import { useStore } from '../../../app/stores/store'
import { history } from '../../..'

function QueuePosition() {
  const { bidsStore } = useStore()
  const { queuePosition, queueTimer } = bidsStore
  const { t } = useTranslation()

  return (
    <div className="newFont prevent-select">
      <Modal
        show={queuePosition > 0}
        aria-labelledby="contained-modal-title-vcenter"
        backdrop="static"
        keyboard={false}
        size="lg"
        centered
      >
        <Modal.Header className="bg-white">
          <p className="post-card-title">{t('queue_header')}</p>
        </Modal.Header>
        <Modal.Body className="post-card-padding pt-5 card-font-size">
          <p className="text-center">{t('queue_txt1')}</p>

          {queueTimer !== 0 ? (
            <p className="text-center text-danger">
              {t('queue_txt2')}: {queueTimer}
            </p>
          ) : (
            <p className="text-center">
              {t('queue_txt3')}: {queuePosition}
            </p>
          )}
        </Modal.Body>
        <Modal.Footer>
          <button
            onClick={() => history.push('/auctions')}
            className="payment-button-cancel text-white"
          >
            {t('go_back')}
          </button>
        </Modal.Footer>
      </Modal>
    </div>
  )
}
export default observer(QueuePosition)
